import { render, staticRenderFns } from "./ShapeEditor.vue?vue&type=template&id=aa60ea14&scoped=true&"
import script from "./ShapeEditor.vue?vue&type=script&lang=js&"
export * from "./ShapeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ShapeEditor.vue?vue&type=style&index=0&id=aa60ea14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa60ea14",
  null
  
)

export default component.exports